import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Grid, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatOptionalField } from "@/pages/manage-vehicles/utils/formatOptionalField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "20px",
  width: "90%",
  maxWidth: "800px",
};

// const CarDetailsStyle = {
//   overflowY: "scroll",
//   height: 500,
//   width: 600,
// };

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 300px;
`;

function CarRow({ name, value, formatEmpty }) {
  const display = formatEmpty ? formatOptionalField(value) : value;

  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {display}
      </Grid>
    </Grid>
  );
}

const ViewVehicleModal = ({ open, handleClose, selectedCar }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <CloseIcon
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            cursor: "pointer",
          }}
          onClick={handleClose}
        />

        <Typography
          variant="h6"
          sx={{
            mb: 2,
          }}
        >
          {selectedCar.car_id}
        </Typography>
        <CarDetails>
          <CarRow name="Car Id" value={selectedCar.car_id} />
          <CarRow name="Make" value={selectedCar.make} />
          <CarRow name="Model" value={selectedCar.model} />
          <CarRow name="Grade" value={selectedCar.grade} />
          <CarRow name="Body" value={selectedCar.body} />
          <CarRow name="Fuel" value={selectedCar.fuel} />
          <CarRow name="Description" value={selectedCar.description} />
          <CarRow name="Engine" value={selectedCar.engine} />
          <CarRow name="Power" value={selectedCar.power} />
          <CarRow name="Transmission" value={selectedCar.transmission} />
          <CarRow name="Drivetrain" value={selectedCar.drivetrain} />

          <CarRow name="Speed" value={selectedCar.speed} />
          <CarRow name="MaxSpeed" value={selectedCar.maxspeed} />
          <CarRow name="Consumption" value={selectedCar.consumption} />
          <CarRow name="Co2" value={selectedCar.co2} />
          <CarRow name="Fuelron" value={selectedCar.fuelron} />
          <CarRow name="Battery" value={selectedCar.battery} formatEmpty />
          <CarRow name="Fueltank" value={selectedCar.fueltank} />
          <CarRow name="Erange" value={selectedCar.erange} />
          <CarRow name="Warranty" value={selectedCar.warranty} />
          <CarRow name="Country" value={selectedCar.country} />
          <CarRow name="Length" value={selectedCar.length} />
          <CarRow name="Width" value={selectedCar.width} />
          <CarRow name="Height" value={selectedCar.height} />
          <CarRow name="Wheelbase" value={selectedCar.wheelbase} />
          <CarRow name="Towing" value={selectedCar.towing} formatEmpty />
          <CarRow name="Seats" value={selectedCar.seats} />
          <CarRow name="Kerbweight" value={selectedCar.kerbweight} />
          <CarRow name="Cargo" value={selectedCar.cargo} />
          <CarRow
            name="Ancap"
            value={selectedCar.ancap === -1 ? "Not Rated" : selectedCar.ancap}
          />
          <CarRow
            name="Airbags"
            value={selectedCar.airbags === -1 ? "TBC" : selectedCar.airbags}
          />
          <CarRow name="Spare" value={selectedCar.spare} />
          <CarRow name="Alternative1" value={selectedCar.alternative1} />
          <CarRow name="Alternative2" value={selectedCar.alternative2} />
          <CarRow name="Alternative3" value={selectedCar.alternative3} />
          <CarRow
            name="Created At"
            value={moment(selectedCar.createdAt).format("MMMM Do YYYY")}
          />
          <CarRow
            name="Updated At"
            value={
              selectedCar.updatedAt
                ? moment(selectedCar.updatedAt).format("MMMM Do YYYY")
                : "Not Specified"
            }
          />
        </CarDetails>
      </Box>
    </Modal>
  );
};

export default ViewVehicleModal;
